export default "__VITE_ASSET__BoaaZlTb__"